import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { ActivityContextService } from 'xsmodules/ticket/components/ticket-details-panel/activity/activity-context';
import { AttachmentActivity } from '../../../../ticket.model';

@Component({
  selector: 'xs-attachment-note',
  templateUrl: './attachment-note.component.html',
  styleUrls: ['./attachment-note.component.scss'],
})
export class AttachmentNoteComponent implements OnInit {
  @Input() parentActivity: AttachmentActivity;
  @Input() placeholder: string;
  @Input() error: string;
  @Input()
  public canEdit: boolean;
  @Input('disable') isSaving = false;
  @Input() activityCtrl: ActivityContextService;
  @Output() saveNote = new EventEmitter<AttachmentActivity>();
  @Output() updateEditing = new EventEmitter<boolean>();

  noteText = '';
  editing = false;
  toggleFocus = false;

  constructor(private xsI18nPipe: XsI18nPipe) {}

  ngOnInit(): void {
    this.noteText = this.parentActivity?.description || '';

    if (this.isNew) {
      this.setEditing(true);
    }
    if (!this.placeholder) {
      this.placeholder = this.xsI18nPipe.transform('note_Placeholder_Text');
    }
  }

  get isNew(): boolean {
    return this.parentActivity && !this.parentActivity.activityId;
  }

  /**
   * Indicates whether the footer should be visible at all in the note
   */
  get isFooterVisible(): boolean {
    return this.hasChanged;
  }

  /** Indicate whether description or privacy flag has changed */
  get hasChanged(): boolean {
    return (this.noteText || '') !== (this.parentActivity?.description || '');
  }

  save() {
    const temp = this.parentActivity;
    temp.description = this.noteText;
    this.saveNote.emit(temp);
  }

  cancel() {
    if (this.isNew) {
      this.activityCtrl.delete();
    } else {
      // This was an update operation... abort it and reset the text
      this.noteText = this.parentActivity.description;
      this.setError(undefined);
    }
  }

  /** Determines whether the note is empty */
  private isEmpty(): boolean {
    return !this.noteText || this.noteText.trim().length === 0;
  }

  private setError(err: string) {
    this.error = err;
  }

  setEditing(value: boolean) {
    this.editing = value;
    this.updateEditing.emit(value);
  }
}
